import app from 'flarum/forum/app';
import Component from 'flarum/common/Component';
import sortWidgets from '../../common/utils/sortWidgets';
export default class StartTopWidgetSection extends Component {
  view() {
    if (!app.widgets.onWidgetPage()) return null;
    if (!app.widgets.get('start_top').length) return null;
    return m("div", {
      className: "FofWidgets-startTop FofWidgets-WidgetSection"
    }, sortWidgets(app.widgets.get('start_top')).map(widget => widget.component.component({
      state: widget.state
    })));
  }
}
flarum.reg.add('fof-forum-widgets-core', 'forum/components/StartTopWidgetSection', StartTopWidgetSection);